import Items from './Items'

export default {
    name: 'kendo-toolbar-item',
    render () {
        return null
    },
    mixins: [
        Items
    ]
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/KendoToolBarItem.js